import axios from "../../../axios";
import * as routes from "../../../api-routes/Manager/Analytics";

export const getBranchInsightsAPI = (token, queryParams) => {
  return axios.get(
    `${process.env.REACT_APP_DASHBOARD_ENDPOINT}${routes.getBranchInsights}`,
    {
      params: {
        ...queryParams,
      },
      headers: {
        token,
      },
    }
  );
};

export const getBranchInsightsTotalAPI = (token, queryParams) => {
  return axios.get(
    `${process.env.REACT_APP_DASHBOARD_ENDPOINT}${routes.getBranchInsightsTotal}`,
    {
      params: {
        ...queryParams,
      },
      headers: {
        token,
      },
    }
  );
};
